import { AlertOptions } from '@ionic/angular';

import { cloneDeep } from 'lodash-es';

export class MiddlewareError extends Error {
  static readonly defaultAlertOptions: AlertOptions = {
    buttons: [
      {
        role: 'cancel',
        text: 'Ok'
      }
    ],
    header: 'Oops'
  };
  alertOptions: AlertOptions;
  constructor(message?: string, alertOptions?: AlertOptions) {
    super(message);
    if (alertOptions) {
      this.alertOptions = alertOptions;
    } else {
      this.alertOptions = cloneDeep(MiddlewareError.defaultAlertOptions);
    }
    this.alertOptions.message = message ?? 'An unknown error occurred';
  }
}
